import { render, staticRenderFns } from "./Customer.vue?vue&type=template&id=3e668d98&scoped=true"
import script from "./Customer.vue?vue&type=script&lang=js"
export * from "./Customer.vue?vue&type=script&lang=js"
import style0 from "./Customer.vue?vue&type=style&index=0&id=3e668d98&prod&lang=css"
import style1 from "./Customer.vue?vue&type=style&index=1&id=3e668d98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e668d98",
  null
  
)

export default component.exports